const normalizeString = (str) => {
    const withoutAccents = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const withoutSpecialChars = withoutAccents.replace(/[&\/\\#,+()$~%'":*?<>{}-]/g,'_');

    return withoutSpecialChars;
}

export default normalizeString;